/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import Img from '~/components/Elements/Img';
import { PaperClip } from '~/components/PaperClip';
import TooltipAR from '~/components/TooltipAR';
import DataLayer from '~/components/DataLayer';
import css from './LivePage.scss';

const classes = {
	// 0.
	root: css.livePage,

	// 1. BACKGROUND
	background: css.livePageBackground,

	// 1. CONTENT
	content: css.livePageContent,
	contentWrapper: css.livePageContentWrapper,

	// 2. PHRASE
	phrase: css.livePagePhrase,

	// 3. CELPHONE
	cel: css.livePageCel,
	celImg: css.livePageCelImg,

	// 4. BUTTON
	buttonTooltip: css.livePageButtonTooltip,
	button: css.livePageButton,
	btn: css.livePageBtn,
 };

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
};

export function LivePage({ classes, className, ...props }) {
	return (
		<div></div>
		// <div className={classes.root}>
		// 	<PaperClip
		// 		className={cls(classes.paperClip)}
		// 		stripes={'#ffb80e'}
		// 		align={PaperClip.ALIGN_LEFT}
		// 	/>
		// 	<section
		// 		id={LivePage.displayName}
		// 		data-ui-anchor={LivePage.displayName}
		// 		className={cls(classes.root, className)}>
		// 		<div className={cls(classes.background)} />
		// 		<div className={cls(classes.content)}>
		// 			<div className={classes.contentWrapper}>
		// 				<div className={cls(classes.phrase)}>
		// 					<Fade>
		// 						<h3>Quer ver a FIAT<br/>Strada pela câmera<br/>do seu celular?</h3>
		// 					</Fade>
		// 				</div>
		// 				<Fade bottom>
		// 					<div className={cls(classes.cel)}>
		// 						<Img
		// 							className={cls(classes.celImg)}
		// 							src='/assets/images/desktop/cel.jpg'
		// 							width={1036}
		// 							height={645}
		// 							// height='auto'
		// 						/>
		// 					</div>
		// 				</Fade>
		// 				<Fade>
		// 					<div className={cls(classes.button)}>
		// 						<DataLayer onEvent={'LivePage_ClicouAtivarVR'} args={[]}>
		// 							<a className={cls(classes.btn)} target="_blank" href='http://stradavirtual.fiat.com.br'>
		// 								Ativar realidade aumentada
		// 							</a>
		// 						</DataLayer>
		// 						<TooltipAR className={cls(classes.buttonTooltip)}/>
		// 					</div>
		// 				</Fade>
		// 			</div>
		// 		</div>
		// 	</section>
		// </div>
	);
}

LivePage.propTypes = propTypes;
LivePage.defaultProps = defaultProps;
LivePage.displayName = 'LivePage';
export default LivePage;
